import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login";
import Dashboard from "../views/Dashboard";
import Panel from "../components/Dashboard/Panel";
import Users from "../views/Users/Users.vue";
import store from "../store";
import NewVehicule from "../views/Vehicules/NewVehicule.vue";
import AdminVehicule from "../views/Vehicules/AdminVehicule.vue";
import Profile from "../views/Profile.vue";
import ReportVehicule from "../views/Vehicules/ReportVehicule.vue";
import NewItem from "../views/Items/NewItem.vue";
import AdminItem from "../views/Items/AdminItem.vue";
import ReportItem from "../views/Items/ReportItem.vue";
import NewTool from "../views/Tools/NewTool.vue";
import AdminTool from "../views/Tools/AdminTool.vue";
import EmployeeNew from "../views/Employees/NewEmployee.vue";
import AdminEmployee from "../views/Employees/AdminEmployee.vue";
import ReportTool from "../views/Tools/ReportTool.vue";
import ReportEmployee from "../views/Employees/ReportEmployee.vue"
import NewRental from "../views/Rentals/NewRental.vue";
import ReportRental from "../views/Rentals/RentalReport.vue";
import ReportPayment from "../views/Payments/ReportPayments.vue";
import NewCrash from "../views/Crashs/NewCrash.vue";
import ReportCrash from "../views/Crashs/ReportCrash.vue";
import NewPayRoll from "../views/Payrolls/NewPayRoll.vue";
import AdminPayRoll from "../views/Payrolls/AdminPayRoll.vue";
import AdminPercentage from "../views/Employees/AdminPercentage.vue";
import NewMision from "../views/Missions/NewMission.vue";
import AdminMision from "../views/Missions/AdminMission.vue";
import NewRunner from "../views/Runners/NewRunner.vue";
import AdminRunner from "../views/Runners/ReportRunner.vue";
import NewSpent from "../views/Spents/NewSpent.vue";
import AdminSpent from "../views/Spents/AdminSpent.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login,
    name: "login",
  },
  {
    path: "/payment-report/:token",
    component: ReportPayment,
    name:"payment-report"
  },
  {
    path: "/dashboard",
    component: Dashboard,

    children: [
      {
        path: "",
        component: Panel,
      },
      {
        path: "/users",
        component: Users,
      },
      {
        path: "/new-vehicule",
        component: NewVehicule,
      },
      {
        path: "/admin-vehicule",
        component: AdminVehicule,
      },
      {
        path: "/report-vehicules",
        component: ReportVehicule,
      },
      {
        path: "/profile",
        component: Profile,
      },
      {
        path: "/new-item",
        component: NewItem,
      },
      {
        path: "/admin-item",
        component: AdminItem,
      },
      {
        path: "/report-item",
        component: ReportItem,
      },
      {
        path: "/new-tool",
        component: NewTool,
      },
      {
        path: "/admin-tool",
        component: AdminTool,
      },
      {
        path: "/new-employee",
        component: EmployeeNew
      },
      {
        path: "/admin-employee",
        component: AdminEmployee
      },
      {
        path: "/report-tool",
        component: ReportTool
      },
      {
        path: "/report-employee",
        component: ReportEmployee
      },
      {
        path: "/new-rental",
        component: NewRental
      }
      , 
      {
        path: "/report-rental",
        component: ReportRental
      },
      {
        path: "/new-crash",
        component: NewCrash
      },
      {
        path: "/report-crash",
        component: ReportCrash
      },
      {
        path: "/new-payroll",
        component: NewPayRoll
      },
      {
        path: "/admin-payroll",
        component: AdminPayRoll
      },
      {
        path: "/admin-percentage",
        component: AdminPercentage
      },
      {
        path: "/new-mission",
        component: NewMision
      },
      {
        path: "/admin-mission",
        component: AdminMision
      },
      {
        path: "/new-runner",
        component: NewRunner
      },
      {
        path: "/admin-runner",
        component: AdminRunner
      },
      {
        path: "/new-spent",
        component: NewSpent
      },
      {
        path: "/admin-spent",
        component: AdminSpent
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

router.beforeEach((to, from, next) => {
  
  if (to.path != "/" && to.name != "payment-report") {
    let token = localStorage.getItem("access_token");
    if (token) {
      if (store.getters.getUser == null) {
        store
          .dispatch("findUserByTokenAction")
          .then(() => {
            if (store.getters.getUser != null) {
              next();
            } else {
              localStorage.removeItem("access_token");
              next("/");
            }
          })
          .catch(() => {
            localStorage.removeItem("access_token");
            next("/");
          });
      } else {
        next();
      }
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
